import { send } from '@interlayer/js/hooks/socket';

export const getServerTime = () => send({
    ID: 406,
    responses: [407],
    description: 'Get OAPI server time object'
}, true);
